/**
 * The SSE event union (D5) — now **generated**, from `../quest-v2-api/events.schema.json`.
 *
 * D5 called this file hand-written "because OpenAPI cannot describe a stream". That was
 * true of OpenAPI and never true of the payloads: BE P6 publishes them as JSON Schema, from
 * the same Pydantic models as `openapi.json`. `pnpm codegen` now reads both documents, so
 * the stream is pinned the same way the REST surface is — by generation rather than by a
 * transcription and a catalogue test.
 *
 * Everything typed lives in `events.generated.ts` and is re-exported here; this file is the
 * import site (`@/api/events`) and holds the two runtime guards, which are behaviour rather
 * than shape. The generated file imports `Change` / `CharacterSnapshot` / `GameTime` /
 * `ErrorDetail` from `@/api/generated` rather than restating them — the stream and the REST
 * surface describe the same game, and the generator fails loudly if the API ever publishes
 * two shapes under one name.
 *
 * **Frames are parsed, not trusted.** Nothing here is validated at runtime by these types;
 * `src/turn/` narrows on the event name and treats an unknown name as ignorable, never
 * fatal (forward compatibility with a BE that adds an event). What generation buys is the
 * other half: an event the backend *removes or renames* fails CI's codegen diff, and a
 * renamed field inside a payload becomes a typecheck error at every site that reads it —
 * which the old catalogue test could not see, and which the recorded fixtures were
 * carrying alone.
 */
import {
  TERMINAL_TURN_EVENT_NAMES,
  TURN_EVENT_NAMES,
  type TurnEvent,
} from '@/api/events.generated';

export * from '@/api/events.generated';

/**
 * `progress.phase` as the DM loop emits it today (`quest/dm/turn.py`). Hand-written, and
 * deliberately not a generated union: the schema types the field as `string` on purpose,
 * because only `label` is rendered and a phase this client has never heard of must render
 * fine rather than fall off a switch. This is a hint for the UI, not a contract.
 */
export const KNOWN_TURN_PHASES = ['resolution', 'narration'] as const;
export type KnownTurnPhase = (typeof KNOWN_TURN_PHASES)[number];

export function isTurnEventName(name: string): name is TurnEvent['event'] {
  return (TURN_EVENT_NAMES as readonly string[]).includes(name);
}

/** The events that end a stream. Exactly one of them arrives. */
export function isTerminalEvent(
  event: TurnEvent,
): event is Extract<TurnEvent, { event: (typeof TERMINAL_TURN_EVENT_NAMES)[number] }> {
  return (TERMINAL_TURN_EVENT_NAMES as readonly string[]).includes(event.event);
}
